module.exports = __webpack_public_path__ + "PTMETTAhome-7.a3def8b9.png";